import TileContainer from 'shared/components/atoms/TileContainer/TileContainer';

export default TileContainer;
